










































import Vue from 'vue';
import ComponentPage from '@/components/page-constructor/ComponentPage.vue';
import ComponentUsageExample from '@/components/page-constructor/ComponentUsageExample.vue';
import AButton from '@/components/AButton.vue';
import AModal from '@/components/AModal.vue';
import { SHORT_LOREM_IPSUM } from '@/config';

interface Data {
  basicUsageModalVisible: boolean;
  customTransitionModalVisible: boolean;
  hideCloseButtonModalVisible: boolean;
}

export default Vue.extend({
  name: 'Modal',
  components: {
    ComponentPage,
    ComponentUsageExample,
    AButton,
    AModal,
  },
  data(): Data {
    return {
      basicUsageModalVisible: false,
      customTransitionModalVisible: false,
      hideCloseButtonModalVisible: false,
    };
  },
  computed: {
    loremIpsum(): typeof SHORT_LOREM_IPSUM {
      return SHORT_LOREM_IPSUM;
    },
  },
});
